// 3. PURE HELPERS
const trimAndUpperCase = (value) =>
  value == null ? value : String(value).trim().toUpperCase();

// 9. EXPORTS
export { trimAndUpperCase };